import { LayerCard, Text } from '@cloudflare/kumo'
import { useTranslation } from '../../i18n'

const STEPS = ['s1', 's2', 's3'] as const

/** "How it works": three numbered steps matching the QR release flow. */
export function PrintSteps() {
  const { t } = useTranslation()
  return (
    <LayerCard>
      <LayerCard.Primary>
        <Text as="h2" variant="heading3" DANGEROUS_className="mb-3">
          {t('print.steps.title')}
        </Text>
        <ol className="flex flex-col gap-3">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-start gap-3">
              <span
                aria-hidden
                className="flex shrink-0 items-center justify-center rounded-full bg-kumo-tint text-sm font-medium text-kumo-default"
                style={{ width: 28, height: 28 }}
              >
                {i + 1}
              </span>
              <span className="pt-0.5 text-sm">{t(`print.steps.${s}`)}</span>
            </li>
          ))}
        </ol>
      </LayerCard.Primary>
    </LayerCard>
  )
}
